export default __webpack_public_path__ + "static/media/creators.73e26c3b.jpg";